import { render, staticRenderFns } from "./SommarTeater.vue?vue&type=template&id=ad90f8de"
import script from "./SommarTeater.vue?vue&type=script&lang=js"
export * from "./SommarTeater.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports